module.exports = __webpack_public_path__ + "static/media/Illus-Location@3x.ab67525d.png";